export default __webpack_public_path__ + "06a7e0b.png";